import { cloneDeep } from 'lodash';

import auroraLandingPageMembershipTabData from '../_data/auroraLandingPageMembershipTabData';
import defaultMembershipTabs from '../_data/defaultLandingPageMembershipTabData';
import trustedAdvisorMembershipTabDataOverrides from '../_data/trustedAdvisorMembershipTabDataOverrides';

const getLandingPageMembershipTabData = (
  isAuroraEnabled: boolean,
  isTrustedAdvisorEnabled: boolean,
) => {
  if (isAuroraEnabled) {
    if (isTrustedAdvisorEnabled) {
      return cloneDeep(auroraLandingPageMembershipTabData).map((tab) => ({
        ...tab,
        tabPanel: {
          ...tab.tabPanel,
          ...trustedAdvisorMembershipTabDataOverrides[tab.id]?.tabPanel,
        },
      }));
    }
    return auroraLandingPageMembershipTabData;
  }
  return defaultMembershipTabs;
};

export default getLandingPageMembershipTabData;
